import script from "./RelaVisitorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RelaVisitorCard.vue?vue&type=script&setup=true&lang=js"

import "./RelaVisitorCard.vue?vue&type=style&index=0&id=2e104734&lang=less&scoped=true"
import "./RelaVisitorCard.vue?vue&type=style&index=1&id=2e104734&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e104734"]])

export default __exports__